//Used for search Criteria
import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';

@resource('searchinfo')
export class SearchInfo extends Entity {
	id: number;
	name: string;
	description: string;
	risk: string;
	details: string;
	entityStatusCode: string;
	entityStatusId: number;
	tagId: number;
	parentId: number;
	ownedById: number;
	ownedByName: string;
	assignedToId: number;
	assignedTo: number;
	assignedToName: string;
	startDate: Date;
	dueDate: Date;
	budget: number;
	cost: number;
	progress: number;
	itemStatusId: number;
	importanceTypeId: number;
	priorityTypeId: number;
	itemTypeId: number;
	closeStatusId: number;
	icon: string;
	showDetails: boolean = true;
}